var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 66,
    viewBox: "0 0 57 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4889 9.93225L50.9883 17.8535V20.799H6.01172V17.8535L28.4889 9.93225ZM28.4889 6.96741L3.5625 15.7524V23.635H53.4375V15.7524L28.4889 6.96741ZM6.29004 53.5864H50.71V54.6176H6.29004V53.5864Z",
    fill: "#39393A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29004 25.2076H50.71V26.2389H6.29004V25.2076Z",
    fill: "#E73B37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57919 56.1903H53.4152V59.0262H3.57919V56.1903ZM11.3666 30.6539V49.1713H14.2611V52.0073H7.58144V49.1713H10.476V30.6539H7.58144V27.818H14.2611V30.6539H11.3666ZM23.0839 30.6539V49.1713H25.9784V52.0073H19.2987V49.1713H22.1933V30.6539H19.2987V27.818H25.9784V30.6539H23.0839ZM34.8012 30.6539V49.1713H37.6957V52.0073H31.016V49.1713H33.9105V30.6539H31.016V27.818H37.6957V30.6539H34.8012ZM46.524 30.6539V49.1713H49.4186V52.0073H42.7389V49.1713H45.6334V30.6539H42.7389V27.818H49.4186V30.6539H46.524Z",
    fill: "#39393A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.9cf9201b6d2ea38644f14f42dd7c6fab.svg";
export { ForwardRef as ReactComponent };